export default "__VITE_ASSET__D5QI2MKb__"